export const socialsData = {
    github: 'https://github.com/kish-00',
    linkedIn: 'https://www.linkedin.com/in/kinuthia-wachira-8920831b1',
}